"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotApiNavigation = void 0;
const tslib_1 = require("tslib");
/**
 * Retrieve information about the dotCMS file and folder tree with the  {@link https://dotcms.com/docs/latest/navigation-rest-api | Navigation REST API }
 *
 */
class DotApiNavigation {
    constructor(httpClient) {
        this.dotCMSHttpClient = httpClient;
    }
    get(depth = '2', location = '/') {
        return this.dotCMSHttpClient
            .request({
            url: `/api/v1/nav/${location}`,
            params: {
                depth
            }
        })
            .then((res) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (res.status === 200) {
                const data = yield res.json();
                return data.entity;
            }
            throw {
                message: yield res.text(),
                statusCode: res.status
            };
        }));
    }
}
exports.DotApiNavigation = DotApiNavigation;
